// slices/filterSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FilterState {
  // name: string;
  categories: string;
  network: string;
  ecoCategories: string;
  impactScore: string;
}

const initialState: FilterState = {
  // name: "",
  categories: "",
  network: "",
  ecoCategories: "",
  impactScore: "",
};

const SearchFilterSlice = createSlice({
  name: "searchFilter",
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<FilterState>) {
      return { ...state, ...action.payload };
    },
    clearFilters() {
      return initialState;
    },
  },
});

export const { setFilters, clearFilters } = SearchFilterSlice.actions;
export default SearchFilterSlice.reducer;
